export const ORBITER_API_ENDPOINT = 'https://api.orbiter.finance/sdk';
export const ORBITER_FEE_DIVIDER = 1_000_000;
